import { createCardHash } from "./bookingPaymentClient";
import type { CardDataForHash, CardTokenResult } from "./bookingPaymentClient";
import { http } from "./http";

export type PaymentTokenizationConfig = {
  ok: boolean;
  scope: "appointment" | "subscription";
  publicKey?: string | null;
  exists?: boolean;
  onlinePaymentEnabled?: boolean;
  onlinePaymentsEnabled?: boolean;
};

export type PaymentTokenizationScope =
  | {
      kind: "appointment";
      establishmentId: string;
    }
  | {
      kind: "subscription";
      authToken: string;
    };

export function getPaymentTokenizationConfig(scope: PaymentTokenizationScope) {
  if (scope.kind === "subscription") {
    return http<PaymentTokenizationConfig>("/payments/tokenization-config/subscription", {
      method: "GET",
      token: scope.authToken,
    });
  }

  return http<PaymentTokenizationConfig>(
    `/payments/tokenization-config/appointment/${scope.establishmentId}`,
    { method: "GET" }
  );
}

export async function createPaymentCardToken(
  card: CardDataForHash,
  scope: PaymentTokenizationScope
): Promise<CardTokenResult> {
  const config = await getPaymentTokenizationConfig(scope);
  const publicKey = String(config?.publicKey || "").trim();

  if (!publicKey) {
    throw new Error(
      "Configuração de pagamento indisponível. Verifique a conexão com a Stone e tente novamente."
    );
  }

  return createCardHash(card, publicKey);
}
